__turbopack_context__.v({
  "backtoTopButton": "style-module-scss-module__qlBm7G__backtoTopButton",
});
